import {
  PROCESSES_DOCUMENT_TEMPLATES_read,
  PROCESSES_DOCUMENT_TEMPLATES_create,
  PROCESSES_DOCUMENT_TEMPLATES_update,
} from "@/data/permission-types.js";

export const processes = {
  path: "processes",
  name: "processes",
  component: () =>
    import(
      /* webpackChunkName: "processes" */ "../../views/processes/ProcessesIndex.vue"
    ),
  meta: {
    requiresAuth: true,
    requiresPermission: true,
  },
  children: [
    // processes > document-templates
    {
      path: "document-templates",
      name: "processes-document-templates",
      component: () =>
        import(
          /* webpackChunkName: "processes-document-templates" */ "../../views/processes/ProcessesDocumentTemplates.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${PROCESSES_DOCUMENT_TEMPLATES_read}`,
      },
    },
    {
      path: "document-templates/new",
      name: "processes-document-templates-new",
      component: () =>
        import(
          /* webpackChunkName: "processes-document-templates" */ "../../views/processes/document-templates/DocumentTemplateNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${PROCESSES_DOCUMENT_TEMPLATES_create}`,
      },
    },
    {
      path: "document-templates/:itemId",
      name: "processes-document-templates-details",
      component: () =>
        import(
          /* webpackChunkName: "processes-document-templates" */ "../../views/processes/document-templates/DocumentTemplateDetails.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${PROCESSES_DOCUMENT_TEMPLATES_read}`,
      },
    },
    {
      path: "document-templates/:itemId/edit",
      name: "processes-document-templates-edit",
      component: () =>
        import(
          /* webpackChunkName: "processes-document-templates" */ "../../views/processes/document-templates/DocumentTemplateEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${PROCESSES_DOCUMENT_TEMPLATES_update}`,
      },
    },
  ],
};
